import {to_isAddressable}      from "@Common/logic/template-options/template-options-is-addressable";
import {cs}                    from "@Common/react/chain-services";
import {consumeContext}        from "@Common/react/context";
import {Load2}                 from "@Common/react/load2";
import {scopedState}           from "@Common/react/scoped-state";
import {UseState}              from "@Common/react/use-state";
import {isDevQuan}             from "@Common/ui-components/debug/is-dev-quan";
import {setCurrentToSaved}     from "@Common/ui-components/heavy/item-options/modules/set-current-to-saved";
import {chain}                 from "@Common/utils/fs";
import {filterKeys, mapValues} from "@Common/utils/objects";

import {Editing} from "./editing/editing";
import {Viewing} from "./viewing/viewing";

export const BulkMailPermitBase = ({templateOptions, initSelected, agentId=undefined, next: rootNext}) => cs(
    consumeContext("company"),
    consumeContext("session"),
    consumeContext("apis"),
    ["allowed", ({company, session}, next) => {
        const branch = session.data?.branch;
        return next(
            templateOptions &&
            to_isAddressable(templateOptions) &&
            templateOptions.options.some((option) => (option.group==="lineItem" && option.dev_key==="mailing_permit")) &&
            company && branch &&
            (
                branch.allowBulkMailPermit === 1 ||
                (branch.allowBulkMailPermit === 2 && company.prefs?.allowBulkMailPermit)
            )
        );
    }],
    // ["showErrors", (_, next) => OneOffInvoke({next})],
    ["selected", (_, next) => UseState({ // If user wants to use bulk mail
        getInitValue: () => chain(
            initSelected,
            // isDevQuan() ? true : (
            //     initSelected
            // ),
            (_) => ({current: _, saved: _}),
        ),
        next,
    })],
    ["editing", (_, next) => UseState({
        // initValue: isDevQuan() ? {
        //     line1: "111",
        // } : null,
        next,
    })],
    ["saved", ({apis, allowed}, next) => Load2({
        _key: allowed,
        fetch: () => !allowed ? null : apis.next.bulkMailPermit.getIndica({agentId}),
        next,
    })],


    ["editingMode", ({editing, saved, apis}, next) => Editing({
        saved: !!saved.value,
        editing,

        onSave: async () => {
            if (saved.value?.idPrimary) {
                await apis.next.bulkMailPermit.saveIndicia({
                    id: saved.value.idPrimary,
                    indicia: mapValues(editing.value, (line) => line?.toUpperCase()),
                    agentId,
                });
                saved.onChange({
                    ...saved.value,
                    ...editing.value,
                });
            } else {
                await apis.next.bulkMailPermit.saveIndicia({
                    indicia: mapValues(editing.value, (line) => line?.toUpperCase()),
                    agentId,
                });
                await saved.reload();
            }

            editing.onChange(null);
        },
        onCancel: () => {
            editing.onChange(null);
        },

        next,
    })],
    ["viewingMode", ({editing, saved}, next) => Viewing({
        saved: saved.value,
        onEdit: () => {
            editing.onChange(
                !saved.value ? {} : filterKeys(saved.value, (k:string) => /^line\d$/.test(k))
            );
        },
        next,
    })],


    ["activeMode", ({selected, editing, editingMode, viewingMode}, next) => next(
        !selected.value.current ? null : (
            editing.value ? (
                editingMode
            ) : (
                viewingMode
            )
        )
    )],

    ({saved, activeMode, editing, selected, allowed}) => rootNext({
        allowed,
        selected: scopedState(selected, ["current"]),
        render: ({showErrors=undefined}={}) => activeMode?.render({showErrors}),
        savedDetails: saved.value,
        saveSelected: () => setCurrentToSaved(selected),
        changed: selected.value.saved !== selected.value.current,
        valid: !editing.value && !saved.loading && saved.value,

        highlightErrors: () => {
            activeMode.highlightErrors();
        },
    }),
);
